import PeopleSchemaAdapter from './base';

export default class Field extends PeopleSchemaAdapter {
  modelNamePlural = 'fields';
}
